export function assertNever(_: never): never {
  console.error("Unexpected value", _);
  throw new Error("Unexpected value");
}
